import {
  Button,
  Typography,
  Container,
  Paper,
  Stack,
} from "@mui/material";
import { CustomSnackbar, Footer, Header } from "../../shared"; // Adjust path as needed
import { rolesAdmin, useSecurityCheck } from "../../../utils"; // Adjust path as needed
import { motion } from "framer-motion";

import { useUtility } from "utils/context/UtilityContext"; // Adjust path as needed
import { usePredefinedListsManager } from "utils/hooks/usePredefinedListsManager";
import { ListManagerDialog } from "features/info/ListManagerDialog";

export const PredefinedListsManager = () => {
  const securityCheck = useSecurityCheck(rolesAdmin);
  const {
    list,
    subCategory,
    open,
    loading,
    isSaving,
    snackbar,
    handleOpenDialog,
    handleCloseDialog,
    handleSaveItem,
    handleDeleteItem,
    handleSnackbarClose,
  } = usePredefinedListsManager();
  
  const { marginBottomHeader } = useUtility(); // Assuming you use this

  if (securityCheck) {
    return securityCheck;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      className={`flex flex-col min-h-screen ${marginBottomHeader}`}
    >
      <Header />

      <Container maxWidth="md" sx={{ flexGrow: 1, py: { xs: 3, md: 5 } }}>
        <Paper sx={{ p: { xs: 2, md: 4 } }}>
          <Stack spacing={2}>
            <Typography variant="h4" component="h1" gutterBottom>
              Gérer les listes prédéfinies
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ mb: 2 }}>
              Gérez les listes de suggestions pour les champs de création de produits.
            </Typography>
            
            {/* Responsive button stack */}
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleOpenDialog("category")}
              >
                Gérer les catégories
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleOpenDialog("provider")}
              >
                Gérer les fournisseurs
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleOpenDialog("name")}
              >
                Gérer les noms
              </Button>
            </Stack>
          </Stack>
        </Paper>
      </Container>

      <Footer />

      {/* The Dialog is now cleaner and only rendered when 'open' is true */}
      {open && (
        <ListManagerDialog
          open={open}
          onClose={handleCloseDialog}
          subCategory={subCategory}
          items={list}
          loading={loading}
          isSaving={isSaving}
          onSave={handleSaveItem}
          onDelete={handleDeleteItem}
        />
      )}

      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        isSuccess={snackbar.severity === "success"}
        handleClose={handleSnackbarClose}
      />
    </motion.div>
  );
};